import {
	VERIFYQRCODEOTP_SUCCESS,
	VERIFYQRCODEOTP_FAILED,
	RESET_VERIFYQRCODEOTP,
	LOADING_VERIFYQRCODEOTP,
	NETWORK_ERROR_VERIFYQRCODEOTP
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetVERIFYQRCODEOTP = () => {
	return { type: RESET_VERIFYQRCODEOTP };
};

const VerifyQrCodeOtpLists = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_VERIFYQRCODEOTP });
	await partnerServices
		.post("verifyQRCodeOtp", userData )
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(VERIFYQRCODEOTPsuccess(res.data));
					break;
				default:
					dispatch(VERIFYQRCODEOTPFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_VERIFYQRCODEOTP,
				payload: err
			});
		});
};
function VERIFYQRCODEOTPsuccess(data) {
	return {
		type: VERIFYQRCODEOTP_SUCCESS,
		payload: data
	};
}
function VERIFYQRCODEOTPFailed(data) {
	return {
		type: VERIFYQRCODEOTP_FAILED,
		payload: data
	};
}

export { resetVERIFYQRCODEOTP, VerifyQrCodeOtpLists };
